import { FC } from 'react';
import { ReactImageGalleryItem } from 'react-image-gallery';
import ImageGallery from 'react-image-gallery';

import classes from './Gallery.module.scss';

import We from '../../assets/we.png';

import Photo1 from '../../assets/gallery/i1.jpg';
import Photo2 from '../../assets/gallery/i2.jpg';
import Photo3 from '../../assets/gallery/i3.jpg';
import Photo4 from '../../assets/gallery/i4.jpg';
import Photo5 from '../../assets/gallery/i5.jpg';
import Photo6 from '../../assets/gallery/i6.jpg';
import Photo7 from '../../assets/gallery/i7.jpg';
import Photo8 from '../../assets/gallery/i8.jpg';
import Photo9 from '../../assets/gallery/i9.jpg';
import Photo10 from '../../assets/gallery/i10.jpg';

const items: ReactImageGalleryItem[] = [
  {
    original: Photo1,
    thumbnail: Photo1,
  },
  {
    original: Photo3,
    thumbnail: Photo3,
  },
  {
    original: Photo4,
    thumbnail: Photo4,
  },
  {
    original: Photo5,
    thumbnail: Photo5,
  },
  {
    original: Photo6,
    thumbnail: Photo6,
  },
  {
    original: Photo7,
    thumbnail: Photo7,
  },
  {
    original: Photo2,
    thumbnail: Photo2,
  },
  {
    original: Photo8,
    thumbnail: Photo8,
  },
  {
    original: Photo9,
    thumbnail: Photo9,
  },
  {
    original: Photo10,
    thumbnail: Photo10,
  },
];

const Gallery: FC = () => {
  return (
    <div className={classes.galleryContainer}>
      <div className={classes.imgBox}>
        <img className={classes.we} src={We} alt="we" />
      </div>
      <ImageGallery items={items} showPlayButton={false} />
    </div>
  );
};

export default Gallery;
